








































































































import { Component, Vue } from "vue-property-decorator";
import { Message } from "element-ui";
import { mapGetters } from "vuex";
import AccountingSystem from "@/data/AccountingSystem";
@Component({
    ...mapGetters(["account"])
})
export default class BatchImport extends Vue {
    options = AccountingSystem;
    value: string = AccountingSystem.thirteenRule;
    filename: string = "";
    bookName: string = "";
    bookCode: string = "";
    key: string = "";
    number: number = 1;
    percentage: number = 0;
    times: number = 0;
    startTime: number = 0;
    endTime: number = 0;
    averageTime: number = 0;
    allTime: number = 0;
    startNum: number = 0;
    disable: boolean = true;

    getFileName(el: any) {
        let filename = el.currentTarget.files[0].name;
        let postfixname = filename.substring(
            filename.length - 3,
            filename.length
        );
        let fileName: any = document.querySelector("#fileInput .fileName");
        if (postfixname != "zip") {
            Message.warning(filename + "是不允许上传的文件类型");
            fileName.innerHTML = "";
        } else {
            fileName.innerHTML = filename;
        }
    }
    fnUpload() {
        let bookName, bookCode, data, num;
        bookName = this.bookName;
        bookCode = this.bookCode;
        num = 0;
        let upfile: any = document.querySelector("#upfile");
        data = new FormData();
        data.append("file", upfile.files[0]);
        data.append("accountingSystem", this.value);
        data.append("bookName", bookName + "_" + (Number(num) + Number(this.startNum)));
        data.append("bookCode", bookCode + (Number(num) + Number(this.startNum)));
        if (this.disable) {
            this.submit(bookName, bookCode, num, data);
        }
    }

    submit(bookName: any, bookCode: any, num: any, data: any) {
        this.disable = false;
        num++;
        this.percentage = Math.floor(num / (this.number) * 100);
        this.startTime = new Date().getTime();
        Vue.axios.post("import/upload", data).then(response => {
            this.key = response.data.key;
            Vue.axios.post("import/bookData?key=" + this.key + "&accounterId=" + this.$store.state.account.id, { "a": 0 }).then(response => {
                this.endTime = new Date().getTime();
                this.allTime = this.allTime + this.endTime - this.startTime;
                this.times = Math.round((this.allTime / num / 1000) * (this.number - num))

                if (num == this.number) {
                    this.disable = true;
                    return;
                }
                this.bookName = bookName + "_" + (Number(num) + Number(this.startNum));
                this.bookCode = bookCode + (Number(num) + Number(this.startNum));
                data = new FormData();
                let upfile: any = document.querySelector("#upfile");
                data.append("file", upfile.files[0]);
                data.append("accountingSystem", this.value);
                data.append("bookName", this.bookName);
                data.append("bookCode", this.bookCode);
                this.submit(bookName, bookCode, num, data);
            });
        });
    }
}
